import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const addSurfaceNodeToSurfaceProtocolNodeMutation = gql`
  mutation addSurfaceNodeToSurfaceProtocolNode(
    $input: AddSurfaceNodeToSurfaceProtocolNodeInput!
    $positionInput: UpdateSurfaceNodePositionInput!
  ) {
    updateSurfaceNodePosition(input: $positionInput) {
      success
      error
    }
    addSurfaceNodeToSurfaceProtocolNode(input: $input) {
      success
      error
    }
  }
`;

export default mutation(addSurfaceNodeToSurfaceProtocolNodeMutation);
